import { camelizeKeys } from "humps";
import includes from "lodash/includes";
import { useCurrentAccount } from "PFCore/hooks/queries/account";
import { CustomValueTag, Id } from "PFCore/types";

export const useCustomValueTags = () => {
  const { data: currentAccount } = useCurrentAccount();

  const allCustomValueTags = currentAccount.custom_value_tags.map(
    (tag) => camelizeKeys(tag) as CustomValueTag
  );

  const getCustomValueTags = (customValueTagIds: Id[] = []) =>
    allCustomValueTags.filter(({ id }) => includes(customValueTagIds, id));

  return {
    getCustomValueTags,
    allCustomValueTags
  };
};
